import examples from "../seo/demo-routes.js";

export function demoFromSearch(search) {
	const id = new URLSearchParams(search).get("demo");
	return examples.find(function (example) { return example.id === id; });
}

export const demo = typeof window === "undefined" ? undefined : demoFromSearch(window.location.search);

export async function loadDemoRoute(example, fetchRoute = fetch) {
	const response = await fetchRoute("/demo-routes/" + example.id + ".json");
	if (!response.ok) {
		throw new Error("Demo route unavailable");
	}
	const points = await response.json();
	if (!Array.isArray(points) || points.length < 2 || points.length > 5000 || points.some(function (point) {
		return !Number.isFinite(point.latitude) || Math.abs(point.latitude) > 90 ||
			!Number.isFinite(point.longitude) || Math.abs(point.longitude) > 180 ||
			!Number.isFinite(point.duration) || point.duration < 0 ||
			!Number.isFinite(point.speed) || point.speed <= 0;
	})) {
		throw new Error("Invalid demo route");
	}
	return points;
}
